import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-picture",
  templateUrl: "./picture.component.html",
  styleUrls: ["./picture.component.scss"],
})
export class PictureComponent implements OnInit {
  @Input() component: any;

  constructor() {}

  ngOnInit() {}
}
